/**
 * Point d'entree de l'application qui permet d'amocer les modules de chaques sites (Backoffice, Lingueopro, Teacher)
 */
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// Meme module que shared/ (fileReplacements) : obligatoire pour que
// loadRuntimeConfig atteigne les services HTTP.
import { environment } from '../../environments/environment';
import { loadRuntimeConfig } from '../../shared/src/lib/runtime-config';
import { AppModule } from './app/manage.module';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

declare function gtag(a: string, b: string, c: any): void;
declare function initCrisp(crispID);

function AnalyzeDomain(env: any) {
    return env.urls.module;
}

function getLanguage() {
    if (localStorage.getItem('language') === null || localStorage.getItem('language') === 'undefined') {
        const browserLanguage = navigator.language.split('-')[0];
        if (environment.urls.languages.map(lang => lang === browserLanguage).length === 1) {
            return browserLanguage;
        }
        return environment.urls.defaultLanguage;
    }
    return localStorage.getItem('language');
}

loadRuntimeConfig(environment as any).then(() => {
    const module_actif = AnalyzeDomain(environment);
    void module_actif;

    localStorage.setItem('language', getLanguage());
    localStorage.setItem('site', environment.urls.module);
    localStorage.setItem('domaine', environment.urls.module);
    localStorage.setItem('default_role', environment.urls.default_role);

    registerLocaleData(localeFr);
    gtag('config', environment.urls.gtagID, { 'app_name': environment.urls.module });
    initCrisp(environment.urls.crispID);

    platformBrowserDynamic().bootstrapModule(AppModule, {
        preserveWhitespaces: true,
    });
});
